/* Bridges AuthContext + LanguageContext.
 * - On login, if user.preferred_lang exists, applies it.
 * - If user toggles language while signed in, persists to backend.
 * Renders no UI. */
import { useEffect, useRef } from 'react';
import { useAuth } from '../lib/auth';
import { useLang } from '../context/LanguageContext';
import { api } from '../lib/api';

const SUPPORTED = ['en', 'es', 'fr', 'zh'];

export default function LanguageSync({ children }) {
  const { user } = useAuth();
  const { lang, setLang } = useLang();
  const syncedUserId = useRef(null);
  const lastSynced = useRef(null);

  useEffect(() => {
    if (!user) {
      syncedUserId.current = null;
      lastSynced.current = null;
      return;
    }
    if (syncedUserId.current !== user.id) {
      syncedUserId.current = user.id;
      const pref = (user.preferred_lang || '').toLowerCase();
      if (SUPPORTED.includes(pref)) {
        lastSynced.current = pref;
        if (pref !== lang) setLang(pref);
        return;
      }
      lastSynced.current = null;
    }
    if (lang === lastSynced.current) return;
    lastSynced.current = lang;
    api.setMyLanguage(lang).then(() => {
      const cached = localStorage.getItem('wyse_user');
      if (cached) localStorage.setItem('wyse_user', JSON.stringify({ ...JSON.parse(cached), preferred_lang: lang }));
    }).catch(() => {});
  }, [user, lang, setLang]);

  return children;
}
